import * as Yup from "yup";
import { Formik } from "formik";

import Text from "../../styleguide/Text";
import { fetchUserToken } from "../../redux/api/auth.api";
import { useAppDispatch, useAppSelector } from "../../redux/hooks";
import TextInput from "../../components/misc/TextInput";
import ContentCard from "../../components/misc/ContentCard";
import CustomButton from "../../components/CustomButton";

const loginSchema = Yup.object().shape({
  name: Yup.string()
    .min(3, "Minim 3 caractere")
    .max(50, "Maxim 50 caractere")
    .required("Adaugati un nume de utilizator"),
  password: Yup.string()
    .min(3, "Minim 3 caractere")
    .max(50, "Maxim 50 caractere")
    .required("Adaugati o parola"),
});

const initialValues = {
  name: "",
  password: "",
};

const Login = () => {
  const dispatch = useAppDispatch();

  const {
    auth: { isLoadingToken },
    user: { isLoadingUser },
  } = useAppSelector((state) => ({
    auth: state.auth,
    user: state.user,
  }));

  const isLoading = isLoadingToken || isLoadingUser;

  const handleLogin = async (values: any) => {
    const userData = {
      userName: values.name,
      password: values.password,
    };
    dispatch(fetchUserToken(userData));
  };

  return (
    <div className="flex h-full flex-col items-center justify-center px-3">
      <ContentCard
        className="w-full max-w-[460px] !px-8 !py-10"
        cardHeaderClassName="!pt-0"
        CardHeader={() => (
          <div className="mb-8 text-center">
            <div className="mx-auto mb-5 h-1 w-12 rounded-full bg-[#2196f3]" />
            <Text variant="h1" component="h1" className="!mb-2">
              Autentificare
            </Text>
            <Text variant="body2" className="text-muted-dark">
              Intră în contul tău pentru a continua.
            </Text>
          </div>
        )}>
        <Formik
          initialValues={initialValues}
          validationSchema={loginSchema}
          onSubmit={handleLogin}>
          {({
            status,
            isValid,
            errors,
            touched,
            getFieldProps,
            handleSubmit,
            isSubmitting,
          }) => (
            <form
              className="w-full"
              onSubmit={handleSubmit}
              noValidate
              id="kt_login_signin_form">
              {status ? (
                <div className="mb-6 rounded-control bg-danger-subtle p-4 text-danger">
                  <div className="font-bold">{status}</div>
                </div>
              ) : null}
              <TextInput
                name="name"
                label="Utilizator"
                error={errors["name"]}
                touched={touched["name"]}
                inputProps={getFieldProps("name")}
              />
              <TextInput
                name="password"
                label="Parolă"
                type="password"
                error={errors["password"]}
                touched={touched["password"]}
                inputProps={getFieldProps("password")}
              />
              <CustomButton
                type="submit"
                fullWidth
                variant="contained"
                size="large"
                className="w-full !min-h-[48px] !text-base"
                disabled={!isValid || isSubmitting || isLoading}
                loading={isLoading}>
                Continuă
              </CustomButton>
            </form>
          )}
        </Formik>
      </ContentCard>
    </div>
  );
};

export default Login;
